import log from './log';

export default {
    sys_monitor: { routerName: '系统监控' },
    ...log,
};
